module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEzIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNNy4zODI5NSA3LjY0NjU0QzYuOTg2MjEgOC4wODI3NiA2LjMwMDEgOC4wODI3NiA1LjkwMzM2IDcuNjQ2NTNMMC42NjEzMzggMS44ODI3OUMwLjA3NzE1NjcgMS4yNDA0NiAwLjUzMjg5MyAwLjIwOTk2IDEuNDAxMTQgMC4yMDk5NkwxMS44ODUyIDAuMjA5OTYxQzEyLjc1MzQgMC4yMDk5NjEgMTMuMjA5MSAxLjI0MDQ3IDEyLjYyNSAxLjg4Mjc5TDcuMzgyOTUgNy42NDY1NFoiIGZpbGw9IiM1MDUwNTAiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/chooseDrop.svg
// module id = 0NDe
// module chunks = 0